import { AUTH_CHANNEL_NAME, type TypeAuthChannelMessage } from '~/constants';

type TypeAuthChannelHandler = (message: TypeAuthChannelMessage) => void;

/**
 * 탭/창 간 인증 상태 동기화를 위한 BroadcastChannel 싱글톤.
 *
 * 같은 origin·같은 브라우저의 다른 탭/창에만 메시지가 전달되며, 발신 탭 자신은 수신하지 않는다.
 * 토큰 등 민감 정보는 전송하지 않고 신호(type)만 보낸다. 수신 측은 IndexedDB를 다시 읽어 상태를 갱신한다.
 */
const authChannelService = (() => {
  const channel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel(AUTH_CHANNEL_NAME) : null;

  const postMessage = (message: TypeAuthChannelMessage) => {
    channel?.postMessage(message);
  };

  const subscribe = (handler: TypeAuthChannelHandler) => {
    if (!channel) {
      return () => {
        /* BroadcastChannel 미지원 환경: 구독 해제할 것이 없음 */
      };
    }

    const listener = (event: MessageEvent<TypeAuthChannelMessage>) => handler(event.data);
    channel.addEventListener('message', listener);

    return () => {
      channel.removeEventListener('message', listener);
    };
  };

  return {
    postMessage,
    subscribe,
  };
})();

export default authChannelService;
